import { render, staticRenderFns } from "./BasePriceBreakdownItem.vue?vue&type=template&id=2bd6eeed&scoped=true&"
import script from "./BasePriceBreakdownItem.vue?vue&type=script&lang=js&"
export * from "./BasePriceBreakdownItem.vue?vue&type=script&lang=js&"
import style0 from "./BasePriceBreakdownItem.vue?vue&type=style&index=0&id=2bd6eeed&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd6eeed",
  null
  
)

export default component.exports